import { httpGET, httpPOST, httpDELETE, json } from './utils';
import { ACTIONS } from '../const';
import { selectBookmark } from '../selectors/bookmarks';

export const getBookmarks = (url, content_id) => dispatch => {
    return httpGET(`${url}${url.includes('?') ? '&' : '?'}limit=0`)
        .then(json)
        .then(bundle => {
            dispatch({
                type: ACTIONS.BOOKMARK_BUNDLE,
                bundle: bundle,
                content_id: content_id,
            });
        });
};

const serverData = (content, page) => ({
    page,
    content_id: content.id,
    content: `/api/v3/content/${content.id}/`,
    slug: content.slug,
    section: `/api/v3/section/${content.section_id}/`,
    type: 'bookmark',
});

const deletedBookmarks = {};

export const bookmarkPage = (content, page) => dispatch => {
    const key = `${content.id}:${page}`;
    dispatch({
        type: ACTIONS.SET_BOOKMARK,
        payload: {
            content_id: content.id,
            page,
        },
    });

    httpPOST('/api/v3/bookmark/', serverData(content, page))
        .then(json)
        .then(data => {
            if (deletedBookmarks[key]) {
                httpDELETE(`/api/v3/bookmark/${data.id}/`);
                return;
            }

            dispatch({
                type: ACTIONS.SET_BOOKMARK,
                payload: {
                    id: data.id,
                    content_id: content,
                    page,
                },
            });
        });
};

export const removeBookmark = (content, page) => (dispatch, getState) => {
    const content_id = content.id;
    const key = `${content_id}:${page}`;

    const bookmark = selectBookmark(getState(), content, page);

    dispatch({
        type: ACTIONS.REMOVE_BOOKMARK,
        payload: {
            content_id: content_id,
            page: page,
        },
    });

    if (bookmark == null || bookmark.id == null) {
        deletedBookmarks[key] = true;
        return;
    }

    httpDELETE(`/api/v3/bookmark/${bookmark.id}/`);
};



// WEBPACK FOOTER //
// ./src/actions/bookmarks.js